var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 6.33334V9.00001L9.66671 10M8.00004 3.33334C4.87043 3.33334 2.33337 5.8704 2.33337 9.00001C2.33337 12.1296 4.87043 14.6667 8.00004 14.6667C11.1297 14.6667 13.6667 12.1296 13.6667 9.00001C13.6667 5.8704 11.1297 3.33334 8.00004 3.33334ZM8.00004 3.33334V1.33334M6.66671 1.33334H9.33337M13.5527 3.72804L12.5527 2.72804L13.0527 3.22804M2.44739 3.72804L3.44739 2.72804L2.94739 3.22804",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockStopwatch);
export default __webpack_public_path__ + "static/media/clock-stopwatch.2b95de927ab7337fac8be2b279887c2d.svg";
export { ForwardRef as ReactComponent };